import axios from "axios";

export const getRegionsOrSearchAction = async (payload) => {
  let response;
  if (payload === undefined) {
    response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/regions/getRegionsWithSearch`
    );
  } else {
    response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/regions/getRegionsWithSearch?searchRegion=${payload}`
    );
  }

  return response.data;
};

export const getFLatRegionsOrSearchAction = async (payload) => {
  try {
    let response;

    if (payload !== undefined) {
      response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/flatregions/search?searchRegion=${payload.regionName}`,
        {
          headers: {
            Authorization: payload.token,
          },
        }
      );
    }

    return response.data;
  } catch (err) {}
};

export const getRegionByIdAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/regions/getRegionById?regionId=${payload.regionId}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const updateRegionAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/regions/updateRegion?regionId=${payload.regionId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const regionSearchAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/regions/regionsearch?regionName=${payload.regionName}`
  );

  return response;
};

export const deleteRegionAction = async (payload) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/regions/deleteRegion?regionId=${payload.regionId}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getAllFlatRegionsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/flatregions/getAllFlatregions?pageNumber=${payload?.page}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getFlatRegionByIdAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/flatregions/${payload.regionId}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const updateFlatRegionAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/flatregions/${payload.regionId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const deleteFlatRegionAction = async (payload) => {
  console.log("payload", payload);

  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/flatregions/delete?id=${payload.id}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const createFlatRegionAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/flatregions`,
    payload.regionPayload,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const updateRegionMetaDataAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/regions/updateRegionZoneData?regionId=${payload.regionId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getRegionMetaDataAction = async (payload) => {
  // console.log("payload", payload);
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/regions/getRegionZoneData?regionId=${payload.regionId}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const updateFlatRegionMetaDataAction = async (payload) => {
  console.log("payload", payload);

  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/flatregions/updatFlatRegionZoneData?regionId=${payload.regionId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getFlatRegionMetaDataAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/flatregions/zoneData?regionId=${payload.regionId}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const transferRegionToFlatreginAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/regions/transferRegionToFlatRegion?id=${payload.id}`,
    {},
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const createPriorityRegion = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/flatregions/priorityRegionCreate`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getPriorityRegions = (payload) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/flatregions/flatPriorityRegionslist`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
};

export const deletePriorityRegionAction = async (payload) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/flatregions/deletePriorityRegion?id=${payload.id}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};
